'use strict';

angular.module('TurneroApp').service('encuestasService', [
    '$resource',
    'portal',
    function ($resource, portal) {

        return $resource(portal.getUrlServer() + 'api/Encuesta/:id', {id: '@Id_Encuesta'}, {
            get: {
                method: 'GET',
                params: {
                    id_Encuesta: '@id_Encuesta'
                },
                url: portal.getUrlServer() + 'api/Encuesta/GetInfo/',
            },
            save: {
                method: 'POST',
                url: portal.getUrlServer() + 'api/Encuesta/',
            },
            'delete': {
                method: 'DELETE',
                params: {
                    Id_Encuesta: '@Id_Encuesta',
                    Id_Estado_Nuevo: '@Id_Estado_Nuevo'
                },
            },
            update: {
                method: 'PUT'
            },
            GetListado: {
                method: 'GET',
                withcredentials: true,
                params: {
                    Id_Centro_Atencion: '@Id_Centro_Atencion',
                    nro_Pagina: '@nro_Pagina',
                    tam_Pagina: '@tam_Pagina',
                    texto: '@texto'
                },
                url: portal.getUrlServer() + 'api/Encuesta/listado/',
            },
            GetFiltros: {
                method: 'GET',
                //params: { id_centro_atencion: '@id_centro_atencion' },
                url: portal.getUrlServer() + 'api/Encuesta/filtro/'
            },
            Get_Historial: {
                method: 'GET',
                url: portal.getUrlServer() + 'api/Encuesta/Get_Historial/'
            },
            cambiarEstado: {
                method: 'PUT',
                params: {
                    Id_Encuesta: '@Id_Encuesta',
                    Id_Estado_Nuevo: '@Id_Estado_Nuevo'
                },
                url: portal.getUrlServer() + 'api/Encuesta/Cambiar_Estado'
            },
            Duplicar: {
                method: 'POST',
                params: { Id_Agenda: '@Id_Encuesta' },
                url: portal.getUrlServer() + 'api/Encuesta/Post_Duplicar_Encuesta'
            },
            getConfiguracionBasica: {
                method: 'GET',
                url: portal.getUrlServer() + 'api/Encuesta/PasoConfigBasica',
                params: {
                    id_encuesta: '@id_encuesta'
                }
            },
            postConfiguracionBasica: {
                method: 'POST',
            },
            putConfiguracionBasica: {
                method: 'PUT',
                url: portal.getUrlServer() + 'api/Encuesta/PasoConfigBasica'
            },
            getComboPreguntas: {
                method: 'GET',
                url: portal.getUrlServer() + 'api/Pregunta/Get_Preguntas_Generales'
            },
            getPasoOpciones: {
                method: 'GET',
                url: portal.getUrlServer() + 'api/Encuesta/PasoOpciones',
                params: {
                    id_encuesta: '@id_encuesta'
                }
            },
            putPasoOpciones: {
                method: 'PUT',
                url: portal.getUrlServer() + 'api/Encuesta/PasoOpciones'
            },
            getComboAgendas: {
                method: 'GET',
                url: portal.getUrlServer() + 'api/Encuesta/Get_Agendas_X_Tramite',
                params: {
                    id_centro_atencion: '@id_centro_atencion',
                    id_tramite: '@id_tramite'
                }
            },
            getComboTramites: {
                method: 'GET',
                url: portal.getUrlServer() + 'api/Encuesta/Get_Tramites_X_Agenda',
                params: {
                    id_centro_atencion: '@id_centro_atencion',
                    id_agenda: '@id_agenda'
                }
            }
        });
    }]);



// WEBPACK FOOTER //
// ./app/components/supervision/encuestas/encuestasService.js